var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('comparison-card',{attrs:{"title":"COMPARISON SITES"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }